export default __webpack_public_path__ + "static/media/coreos.f50a3c26.svg";